<div class="container" id="outagemaindiv">
  <div class="filter-bar">
    <div class="filter-group">
      <mat-checkbox [(ngModel)]="includeResolved" labelPosition="before" (change)="getOutages()">Include Resolved
      </mat-checkbox>
    </div>
    <div class="filter-group eca-fx-row">
      <label>Filter</label>
      <mat-form-field class="eca-search">
        <eca-search matInput [(ngModel)]="outageFilter" (ngModelChange)="filterOutages()"></eca-search>
      </mat-form-field>
    </div>
    <div class="button-group">
      <button mat-button (click)="openCreateOutageModal()">New Issue</button>
    </div>
  </div>
  <div class="table-container">
    <mat-table [dataSource]="dataSource" #sort="matSort" matSort>

      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
        <mat-cell *matCellDef="let issue">{{issue.title}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let issue" [ngClass]="getClass(issue.status)">{{issue.status}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="severity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Severity</mat-header-cell>
        <mat-cell *matCellDef="let issue" [ngStyle]="{'color': getClass(issue.severity)}">{{issue.severity}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="clients">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Clients</mat-header-cell>
        <mat-cell *matCellDef="let issue">{{issue.clients}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="services">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Services</mat-header-cell>
        <mat-cell *matCellDef="let issue">{{getServiceNames(issue.services)}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="createTime">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created On</mat-header-cell>
        <mat-cell *matCellDef="let issue">{{issue.createTime | date: 'short'}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell *matCellDef="let issue">
          <div class="button-group action-buttons">
            <button mat-button (click)="openUpdateOutageModal(issue)" [disabled]="issue.status == 'Resolved'">Update</button>
            <button mat-button (click)="viewOutageUpdates(issue)">View</button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>
    <eca-paginator #paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"
      [pageSizeSelection]="true" [totals]="true" id="eca-paginator">
    </eca-paginator>
  </div>
</div>
@if (inprogress) {
  <div class="loading-overlay">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </div>
}

<!-- <mat-tab-group [@.disabled]="true">
<mat-tab label="View Active Issues">
  <div>
    <mat-card fxLayout="column" fxFlex="100%">
      <mat-card-header>
        <div fxLayout="row wrap" fxLayoutGap="24px grid" class="filter-bar">
          <div id="sevierity" class="filter-group">
            <label>Severity</label>
            <mat-form-field>
              <mat-select matInput placeholder="Select Severity" [(ngModel)]="selectedSeverity"
                (selectionChange)="prepareOutastandingTableData()">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let serviceStatus of getServiceStatusList()" [value]="serviceStatus">
                {{serviceStatus}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div id="affectedclient" class="filter-group">
            <label>Affected Client</label>
            <mat-form-field>
              <mat-select matInput placeholder="Select Client" [(ngModel)]="selectedClient"
                (selectionChange)="prepareOutastandingTableData()">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let client of clientList" [value]="client.clientId">
                {{client.clientId}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div id="affectedservice" class="filter-group">
            <label>Affected Service</label>
            <mat-form-field>
              <mat-select matInput placeholder="Select Service" [(ngModel)]="selectedService"
                (selectionChange)="prepareOutastandingTableData()">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let service of serviceList" [value]="service.serviceName">
                {{service.serviceName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div id="filterarea" fxFlex fxLayoutAlign="end" class="filter-group">
            <mat-form-field>
              <input matInput placeholder="Search" (keyup)="filterActiveObjects($event.target.value)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <div id="saveallbtn" fxFlex fxLayoutAlign="end" class="filter-group">
            <button mat-button class="mat-small-button" [matMenuTriggerFor]="exportTypeMenu"
              #matMenuTrigger="matMenuTrigger" [matMenuTriggerData]="{name: 'Active'}">
              <span>Save As</span>
              <mat-icon class="mat-icon material-icons mat-incon-keyboard_arrow_down">keyboard_arrow_down</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="column" id="activetable">
          <mat-table [dataSource]="outstandingDataSource" #sort="matSort" matSort>

            <ng-container matColumnDef="issueId">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Issue ID</mat-header-cell>
              <mat-cell *matCellDef="let issue">
                <a (click)="openIssueDialog(issue)" style="cursor: pointer;">{{issue.issueId}}</a></mat-cell>
              </ng-container>

              <ng-container matColumnDef="issueTitle">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Issue Title</mat-header-cell>
                <mat-cell *matCellDef="let issue">{{issue.issueTitle}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="issueState">
                <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
                <mat-cell *matCellDef="let issue" [ngClass]="getClass(issue.issueState)">{{issue.issueState}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="issueStatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                <mat-cell *matCellDef="let issue" [ngClass]="getClass(issue.issueStatus)">{{issue.issueStatus}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="affectedClients">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Clients</mat-header-cell>
                <mat-cell *matCellDef="let issue">{{issue.affectedClients}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="affectedServices">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Services</mat-header-cell>
                <mat-cell *matCellDef="let issue">{{issue.affectedServices}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Created On</mat-header-cell>
                <mat-cell *matCellDef="let issue">{{issue.createDate}}</mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="outstandingColumns"></mat-header-row>

              <mat-row *matRowDef="let row; columns: outstandingColumns" (dblclick)="openIssueDialog(row)"></mat-row>

            </mat-table>
          </div>

        </mat-card-content>
      </mat-card>

    </div>
  </mat-tab>

  <mat-tab label="View Resolved Issues">
    <div>
      <mat-card fxLayout="column" fxFlex="100%">
        <mat-card-header>
          <div fxLayout="row wrap" fxLayoutGap="24px grid" class="filter-bar">
            <div id="sevierityr" class="filter-group">
              <label>Severity</label>
              <mat-form-field>
                <mat-select matInput placeholder="Select Severity" [(ngModel)]="selectedSeverityr"
                  (selectionChange)="prepareResolvedTableData()">
                  <mat-option [value]="null"></mat-option>
                  <mat-option *ngFor="let serviceStatus of getServiceStatusList()" [value]="serviceStatus">
                  {{serviceStatus}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div id="affectedclientr" class="filter-group">
              <label>Affected Client</label>
              <mat-form-field>
                <mat-select matInput placeholder="Select Client" [(ngModel)]="selectedClientr"
                  (selectionChange)="prepareResolvedTableData()">
                  <mat-option [value]="null"></mat-option>
                  <mat-option *ngFor="let client of clientList" [value]="client.clientId">
                  {{client.clientId}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div id="affectedservicer" class="filter-group">
              <label>Affected Service</label>
              <mat-form-field>
                <mat-select matInput placeholder="Select Service" [(ngModel)]="selectedServicer"
                  (selectionChange)="prepareResolvedTableData()">
                  <mat-option [value]="null"></mat-option>
                  <mat-option *ngFor="let service of serviceList" [value]="service.serviceName">
                  {{service.serviceName}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div id="filterarear" fxFlex fxLayoutAlign="end" class="filter-group">
              <mat-form-field>
                <input matInput placeholder="Search" (keyup)="filterResolvedObjects($event.target.value)">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div id="saveallbtnr" fxFlex fxLayoutAlign="end" class="filter-group">
              <button mat-button class="mat-small-button" [matMenuTriggerFor]="exportTypeMenu"
                #matMenuTrigger="matMenuTrigger" [matMenuTriggerData]="{name: 'Resolved'}">
                <span>Save As</span>
                <mat-icon class="mat-icon material-icons mat-incon-keyboard_arrow_down">keyboard_arrow_down</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="column" id="activetable">
            <mat-table [dataSource]="resolvedIssuesDataSource" #sort2="matSort" matSort>

              <ng-container matColumnDef="issueId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Issue ID</mat-header-cell>
                <mat-cell *matCellDef="let issue">
                  <a (click)="openIssueDialog(issue)" style="cursor: pointer;">{{issue.issueId}}</a></mat-cell>
                </ng-container>

                <ng-container matColumnDef="issueTitle">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Issue Title</mat-header-cell>
                  <mat-cell *matCellDef="let issue">{{issue.issueTitle}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="issueState">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
                  <mat-cell *matCellDef="let issue" [ngClass]="getClass(issue.issueState)">{{issue.issueState}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="issueStatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                  <mat-cell *matCellDef="let issue" [ngClass]="getClass(issue.issueStatus)">{{issue.issueStatus}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="affectedClients">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Clients</mat-header-cell>
                  <mat-cell *matCellDef="let issue">{{issue.affectedClients}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="affectedServices">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Affected Services</mat-header-cell>
                  <mat-cell *matCellDef="let issue">{{issue.affectedServices}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="createDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
                  <mat-cell *matCellDef="let issue">{{issue.createDate}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="resolveDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Resolved</mat-header-cell>
                  <mat-cell *matCellDef="let issue">{{issue.resolveDate}}</mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="resolvedColumns"></mat-header-row>

                <mat-row *matRowDef="let row; columns: resolvedColumns" (dblclick)="openIssueDialog(row)"></mat-row>

              </mat-table>
              <mat-paginator [pageSize]="10"></mat-paginator>
            </div>
          </mat-card-content>
        </mat-card>

      </div>
    </mat-tab>

    <mat-tab label="Create Issue">
      <div>
        <mat-card fxLayout="column" fxFlex.gt-md="50%" fxFlex.lt-lg="100%">
          <mat-card-content>
            <div>
              <p *ngIf="hasError" class="haserror subtitle-2">{{errorMessage}}</p>
              <p *ngIf="hasSuccess" class="hassuccess subtitle-2">{{successMessage}}</p>
              <p *ngIf="inprogress" clas="spinner">
                <mat-spinner diameter="15"></mat-spinner>
              </p>
            </div>

            <mat-form-field id="clientselectionform">
              <mat-label id="clientIdLabel">Select Client(s)</mat-label>
              <mat-select placeholder="Select Client" multiple [compareWith]="compareAffectedServicesChecked"
                disableOptionCentering name="selectedClients" [(ngModel)]="selectedClientList">
                <mat-option disabled="true" class="optionbutton">
                  <button class="mat-small-button" mat-button (click)="selectAllClients()">Select All</button>
                  <button class="mat-small-button" mat-button (click)="deSelectAllClients()">Deselect All</button>
                </mat-option>
                <mat-divider></mat-divider>
                <mat-option *ngFor="let cl of clientList" [value]="cl">{{cl.clientId}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field id="issueTitle" style="width:100% !important">
              <mat-label id="issueupdatetextLabel">Title</mat-label>
              <input matInput [(ngModel)]="issueNew.issueTitle" name="issueTitle" placeholder="Issue Title"
                [value]="issueNew.issueTitle" required>
            </mat-form-field>

            <p>
              <mat-form-field id="issuetextfiled" style="width:100% !important">
                <mat-label id="issuetextLabel">Issue Description*</mat-label>
                <textarea matInput placeholder="Enter the text wish to post here..." [(ngModel)]="issueNewDescription"
                rows="3" name="issueNewDescription" [value]="issueNewDescription"></textarea>
              </mat-form-field>
            </p>

            <p fxLayout="row">
              <span id="stateLabel" style="margin-top: 10px; margin-right:24px;" class="subtitle-2">State*: </span>
              <mat-button-toggle-group #group="matButtonToggleGroup" [(ngModel)]="issueNew.issueState" fxHide.lt-md>
                <mat-button-toggle *ngFor="let serviceState of serviceStateList" [value]="serviceState">
                  <span [ngClass]="getClass(serviceState)">{{serviceState}}</span>
                </mat-button-toggle>
              </mat-button-toggle-group>
              <mat-radio-group class="radio-group" [(ngModel)]="issueNew.issueState" fxHide.gt-sm name="issueStateradio">
                <mat-radio-button class="radio-button" *ngFor="let serviceState of serviceStateList"
                  [value]="serviceState">
                  <span [ngClass]="getClass(serviceState)">{{serviceState}}</span>
                </mat-radio-button>
              </mat-radio-group>

            </p>
            <p fxLayoutGap="24px" fxLayout="row wrap">
              <mat-form-field>
                <mat-label id="servicesaffectedLabel" class="full-width">Services affected?</mat-label>
                <mat-select multiple [compareWith]="compareAffectedServicesChecked" name="issueNewServicesAffected"
                  [(ngModel)]="issueNewServicesAffectedList" required>
                  <mat-option *ngFor="let service of serviceList" [value]="service">
                    {{ service.serviceName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field id="servicestatusfield">
                <mat-label id="servicestatusLabel">Services Status</mat-label>
                <mat-select placeholder="Don't change service status" disableOptionCentering name="issueNew.issueStatus"
                  [(ngModel)]="issueNew.issueStatus" required>
                  <mat-option *ngFor="let svc of serviceStatusList" [value]="svc">{{svc}}</mat-option>
                </mat-select>
              </mat-form-field>
            </p>

            <p>
              <mat-card-actions align="end">
                <button
                  [disabled]="!issueNew.issueTitle || selectedClientList.length == 0 || issueNewServicesAffectedList.length == 0 || !issueNew.issueStatus || !issueNew.issueState"
                mat-button class="mat-small-button" (click)="postissue()">POST ISSUE</button>
              </mat-card-actions>
            </p>

          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

  </mat-tab-group>
  <mat-menu #exportTypeMenu="matMenu" [overlapTrigger]="false" class="dropdown-menu-panel">
    <ng-template matMenuContent let-name="name">
      <button mat-menu-item (click)="exportAllToPDFOrExcel('pdf', name)">PDF</button>
      <button mat-menu-item (click)="exportAllToPDFOrExcel('excel', name)">Excel</button>
    </ng-template>
  </mat-menu> -->